export function pickLocalizedName(language, name, nameArabic, nameHebrew) {
  if (language === "ar" && nameArabic) return nameArabic;
  if (language === "he" && nameHebrew) return nameHebrew;
  return name;
}

export function localizedProductName(language, product) {
  return pickLocalizedName(language, product?.name, product?.nameArabic, product?.nameHebrew);
}

export function localizedProductDescription(language, product) {
  return pickLocalizedName(language, product?.description, product?.descriptionArabic, product?.descriptionHebrew);
}

// Variant names are stored in English (e.g. "Red / M"), so build the label
// from the variant's translated option values when they exist.
export function localizedVariantName(language, variant) {
  const values = variant?.attributeValues ?? [];
  if (values.length === 0) return variant?.variantName ?? "";
  return values.map((av) => localizedOptionValue(language, av)).join(" / ");
}

// Clothing size codes (XS, S, M, L, XL, 2XL, XXXL, 3XL...) and plain numbers
// (shoe sizes, ages) read the same in every language, so never translate them.
const SIZE_CODE = /^(\d*X{0,4}[SML]|\d+X{1,4}L|free\s*size|one\s*size|\d+(\.\d+)?(\s*-\s*\d+(\.\d+)?)?)$/i;

export function localizedOptionValue(language, av) {
  const value = av?.optionValue;
  if (value && SIZE_CODE.test(value.trim())) return value;
  return pickLocalizedName(language, value, av?.optionValueArabic, av?.optionValueHebrew);
}

// Cart, wishlist and order lines carry productName/productNameArabic/productNameHebrew.
export function localizedItemProductName(language, item) {
  return pickLocalizedName(language, item?.productName, item?.productNameArabic, item?.productNameHebrew);
}
